export var InternalFeature;
(function (InternalFeature) {
    InternalFeature["Vaults"] = "vaults";
})(InternalFeature || (InternalFeature = {}));
